export default __webpack_public_path__ + "static/media/sc38.b2646d03.mp4";